import {Component, Input} from "@angular/core";

@Component({
  selector: 'loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.css']
})
export class LoadingSpinnerComponent {
  @Input() showSpinner: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/loading-spinner/loading-spinner.component.ts